var quiz = {
    questions: [{
        text: "Given the following Java code:\r\n\r\njava.lang.String str1 = \"hello\";\r\njava.lang.String str2 = \"hello\";\r\n\r\nSelect the statement that is always true in all JVMs:\r\n",
        responses: [{
            text: "str1.equals(str2)",
            index: 'A',
            correct: true
          },
          {
            text: "str1 == str2",
            index: 'B'
          },
          {
            text: "!str1.equals(str2)",
            index: 'C'
          },
          {
            text: "str1 != str2",
            index: 'D'
          }
        ]
      },
      {
        text: "Given the following Java code, pick the correct statement from a hacking standpoint:\r\n\r\n100 \r\n101 try {\r\n102  String creditCardNumber = \"1234567890\";\r\n103  \/\/.....do some operations with creditCardNumber\r\n104  creditCardNumber = \"**********\";\r\n105 } finally {\r\n106   \/\/.....\r\n107 }\r\n108",
        responses: [{
            text: "once we reach line 104, we blank out the creditCardNumber; the original value is not recoverable;",
            index: 'A'
          },
          {
            text: "creditCardNumber comes out of scope beyond line 105 becoming inaccessible and flagged for garbage collection; the original value is not recoverable;",
            index: 'B'
          },
          {
            text: "both a and b ensure reasonable data safety against buffer overflow attacks;",
            index: 'C',
          },
          {
            text: "garbage collection operates on a non-deterministic schedule and offers a window for buffer overflow attacks;",
            index: 'D',
            correct: true
          }
        ]
      },
      {
        text: "When encrypting the secrets \"1234a secret\" and \"1234another secret\" with AES in ECB mode, which of the following output patterns can be expected in the ciphertext:",
        responses: [{
            text: "\"kdie98087234jhfmnxcf\" and \"kdie98723hjgsaukmnxcf\"",
            index: 'A',
            correct: true
          },
          {
            text: "\"902813jksaklkliuwaea\" and \"6125312,mndshakjdhasd\"",
            index: 'B'
          },
          {
            text: "\"1234a secret\" and \"1234another secret\"",
            index: 'C'
          },
          {
            text: "\"kjsahdkjsah190128343\" and \"iqwuesjkasdj190128343\"",
            index: 'D'
          }
        ]
      },
      {
        text: "The legacy system of a large bank is a batch processor.  Each job must be processed in a fixed order.  The bank invests in cloud computing hardware which can execute a large number of jobs in parallel, getting the job done in a fraction of the time.  The following code is proposed:\r\n\r\nList<String> nonMarkovianInOrderBatchProcessing = getJobsFromLegacySystem();\r\nlist.parallelStream().forEach(batchJob -> {\r\n\tprocess(batchJob);\r\n});\r\n\r\nYou should:",
        responses: [{
            text: "accept the code because its throughput will be higher;",
            index: 'A'
          },
          {
            text: "reject the code because its throughput will be lower;",
            index: 'B'
          },
          {
            text: "accept the code because it promotes horizontal scaling architecture;",
            index: 'C',
          },
          {
            text: "reject the code because records will be processed in non-deterministic orde",
            index: 'D',
            correct: true
          }
        ]
      },
      {
        text: "Frequent hash code collisions may likely exacerbate which problem:",
        responses: [{
            text: "slow SQL database performance due to deadlocking;",
            index: 'A'
          },
          {
            text: "reduced performance in a key-value Map with linear probing;",
            index: 'B',
            correct: true
          },
          {
            text: "buffer overflow attacks",
            index: 'C'
          },
          {
            text: "poor performance from thread thrashing and livelock ",
            index: 'D'
          }
        ]
      }
    ]
  },
  userResponseSkelaton = Array(quiz.questions.length).fill(null);
import {
  bus
} from '../../main';
import VueCircle from 'vue2-circle-progress/src/index.vue'
var $ = window.jQuery = require('jquery');
import Vue from 'vue'
export default {
  name: 'quiz-format',
  components: {
    VueCircle
  },
  props: [],
  data() {
    return {
      fill: {
        color: "#0cbfe9"
      },
      quiz: quiz,
      questionIndex: 0,
      userResponses: [],
      quizStarted: true,
      isActive: false,
      totalTime: 90,
      totalScore: 0,
      countDown: {
        minutes: "00",
        seconds: "00"
      }
    }
  },
  computed: {

  },
  mounted() {
    var totalTime = new Date();
    totalTime.setSeconds(totalTime.getSeconds() + this.totalTime);
    this.initializeTimer(totalTime)
  },
  methods: {
    selectOption: function(index) {
      Vue.set(this.userResponses, this.questionIndex, index);
    },
    next: function() {
      if (this.questionIndex < this.quiz.questions.length) {
        this.questionIndex++;
        this.score()
      }
    },
    prev: function() {
      if (this.quiz.questions.length > 0) this.questionIndex--;
    },
    // Return "true" count in userResponses
    score: function() {
      var score = 0;
      for (let i = 0; i < this.userResponses.length; i++) {
        if (
          typeof this.quiz.questions[i].responses[
            this.userResponses[i]
          ] !== "undefined" &&
          this.quiz.questions[i].responses[this.userResponses[i]].correct
        ) {
          score = score + 1;
        }
      }
      this.totalScore = score;
      return score;
    },

    //   CountDown
    initializeTimer: function(endTime) {
      var _self = this;

      function updateClock() {
        let remainTime = _self.getTimeRemaining(endTime)
        _self.countDown = remainTime;
        _self.UpdatePercentage(remainTime.total);
        if (remainTime.total <= 0) {
          clearInterval(timeinterval);
        }
      }
      updateClock();
      var timeinterval = setInterval(updateClock, 1000);
    },
    getTimeRemaining(endTime) {
      var t = Date.parse(endTime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      return {
        'total': t,
        'minutes': minutes,
        'seconds': seconds
      };
    },
    UpdatePercentage(remainTime) {
      let totalTime = (this.totalTime) * 1000;
      let percentage = 100 - ((remainTime * 100) / totalTime)
      if (this.$refs.timerRef)
        this.$refs.timerRef.updateProgress(percentage);
    },
    showCategory() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('showQuizGameCS', false);
      }, 500);
      setTimeout(() => {
        bus.$emit('hideQuizCategory', true);
      }, 500);
      setTimeout(() => {
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 600);
    },
    QuizGamePopupClose() {
      $(".quizzort_main_wrp").removeClass("popup_active");
      setTimeout(() => {
        bus.$emit('showQuizGameCS', false);
        bus.$emit('hideQuizzortPopupEnabled', false);
        $("body").removeClass("quizzort_popup_active");
      }, 500)
    },
    progressInit(event) {
      //console.log(stepValue);
    },
    progress_end(event) {
      //console.log("Circle progress end");
    }
  },
}